<template>
  <div>
    <template v-if="splited">
      <template v-for="g in type_groups">
        <div :key="`_type${g.id}`" style="margin:10px 5px;padding:3px 5px;border-left:5px solid var(--primary);padding-left:10px;">
          <div class="flex-wrap">
            <div>
             <div>{{g.business_type}}</div>
             <BaseAmount :value="g.amount" />
            </div>
          </div>
        </div>
        <div :key="`_list${g.id}`" style="border:1px solid var(--border);overflow:hidden;margin:5px;">
         <Row :gutter="10" class-name="l-bill" style="border-bottom:1px solid var(--border);background:var(--bg2)">
          <Col :span="2"  style="text-align:center">序号</Col>
          <Col :span="3"  style="text-align:center" v-if="splited">服务类型</Col>
          <Col :span="6">收费条款</Col>
          <Col :span="8" style="text-align:right" >收费金额</Col>
          <Col :span="3"  style="text-align:right">占比</Col>
        </Row>

        <BaseEmpty v-if="g.list.length == 0" style="padding:20px;" msg="暂无条目" />
        <template v-for="(data,index) in g.list">
          <Row :key="data.id" :gutter="10" class-name="l-bill">
          <Col :span="2"  style="text-align:center">{{index+1}}</Col>
          <Col :span="9" >{{data.detail}}</Col>
          <Col :span="8"  ><BaseAmount full :value="data.amount"></BaseAmount></Col>
          <Col :span="3"  style="text-align:right;color:var(--success)">{{fix(data.percent,2)}} %</Col>

        </Row>
        </template>
        <Row :gutter="10" class-name="l-bill   l-bill-summary" v-if="items.length > 0">
          <Col :span="4">合计</Col>
          <Col :span="3" v-if="splited"> </Col>
          <Col :span="12">
          <BaseAmount :value="amount" full></BaseAmount>
          </Col>
        </Row>
        </div>
      </template>
    </template>
    <template v-else>
    <Row :gutter="10" class-name="l-bill">
      <Col :span="2"  style="text-align:center">序号</Col>
       <Col :span="3"  style="text-align:center" v-if="splited">服务类型</Col>
      <Col :span="6">收费条款</Col>
       <Col :span="8" style="text-align:right" >收费金额</Col>
      <Col :span="3"  style="text-align:right">占比</Col>
    </Row>

    <BaseEmpty v-if="items.length == 0" style="padding:20px;" msg="暂无条目" />
    <template v-for="(data,index) in items">
      <Row :key="data.id" :gutter="10" class-name="l-bill">
      <Col :span="2"  style="text-align:center">{{index+1}}</Col>
      <Col :span="3" style="text-align:center"  v-if="splited">{{data.business_type}}</Col>
      <Col :span="6" >{{data.detail}}</Col>
       <Col :span="8"  ><BaseAmount full :value="data.amount"></BaseAmount></Col>
      <Col :span="3"  style="text-align:right;color:var(--success)">{{fix(data.percent,2)}} %</Col>

    </Row>
    </template>
    <Row :gutter="10" class-name="l-bill   l-bill-summary" v-if="items.length > 0">
      <Col :span="4">合计</Col>
      <Col :span="3" v-if="splited"> </Col>
      <Col :span="12">
      <BaseAmount :value="amount" full></BaseAmount>
      </Col>
    </Row>
    </template>
  </div>
</template>
<script>
import {fix} from '@/utils/calc';
export default {
  data() {
    return {
    };
  },
  props: {
    value: {
      type: Object,
      default: ()=>({}),
    },
  },
  methods: {
    fix,
  },
  computed: {
    type_groups() {
      if (this.value.splited) {
        return this.value.condition_groups.map((v)=>{
          return {...v, list: this.value.conditions.filter((c)=>c.business_type == v.business_type)};
        }).filter((v)=>v.list.length > 0);
      } else {
        return [];
      }
    },
    splited() {
      return this.value?this.value.splited:false;
    },
    items() {
      return this.value.conditions || [];
    },
    amount() {
      return this.items.reduce((c, item) => {
        return c + item.amount;
      }, 0);
    },
    percent() {
      return this.items.reduce((c, item) => {
        return c + item.percent;
      }, 0);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
